import {useState, useEffect, useMemo} from 'react';
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import Table from '../table';
import ActionBar from '../actionBar';
import {dateFormatter} from '../dateFormatter';
import {useAtomValue} from 'jotai';
import {pageSizeRecoil} from '../recoil';
import Portal from '../portal';
import AlertDetail from './alertDetail';

export const Alerts = props => {
  const [pageNum, setPageNum] = useState(1);
  const [totalRecordsState, setTotalRecordsState] = useState(0);
  const pageSize = useAtomValue(pageSizeRecoil);

  const msgFilters = useMemo(() => ({
    combineAnd: [
      { field: "options.sort_fields", value: "issue_code.asc" },
      { field: "options.show_deleted", value: `false` },
      { field: "options.page.num", value: `${pageNum}` },
      { field: "options.page.len", value: `${pageSize}` }
    ]
  }), [pageNum, pageSize]);
  
  const {data, loading} = useQuery(MSG, {
    variables: { filters: msgFilters }
  });
  
  const totalQueried = data?.EUMessages?.metadata?.page?.records ?? totalRecordsState;

  useEffect(()=> {
    setTotalRecordsState(totalQueried);
  }, [totalQueried]);

  const messages = data?.EUMessages?.result ?? [];

  const columns = [
    { dataField: 'id', hidden: true },
    { dataField: 'issue_message', text: 'Issue Message' },
    { dataField: 'action_message', text: 'Action Message' },
    { dataField: 'modified_at', text: 'Last Updated (UTC)', formatter: dateFormatter }
  ];
  
  return (
    <>
      <Portal title="Messaging">
        <AlertDetail title="Edit Message" type="msg"  />
      </Portal>
      <ActionBar
        showHidden={false}
        showSearchBar
        showSearchInput={false}
        title="Manage Messaging"
        pageDescription="These features are only available for SafeCase CRBN [i15] and CRBN X [S23]."
      />
      
      <Table
        testId="alerts-table"
        columns={columns}
        data={messages}
        loading={loading}
        pageSize={pageSize}
        pageNum={pageNum}
        setPageNum={setPageNum}
        totalRecords={totalRecordsState}
      />
    </>
  );
};

const MSG = gql`
query getEUMessage ($filters: GenericFilters) {
  EUMessages(filters: $filters) {
    result {
      id
      issue_code
      issue_message
      action_message
      modified_at
    }
    metadata { page { num len total inPage records } } 
  }
}
`;

export default Alerts;
